import { CodeModel } from "../../administration/models/code.model";

export const ReportByModel: CodeModel[] = [
  { code: "Division", description: "Division" },
  { code: "Charge AFE/CC", description: "Charge AFE/CC" },
  { code: "Request Type", description: "Request Type" },
  { code: "Approver", description: "Approver" },
  { code: "Month", description: "Month" }
]